export default __webpack_public_path__ + "static/media/marketing.c1a804ef.png";